// extracted by mini-css-extract-plugin
export default {"bannerArrows":"BannerPortal_bannerArrows__Mbu41"};